import Blocker from "@/components/Blocker";
import { usePlanChanges } from "@/stores/use-plan-table";

function PlanBlocker() {
    const changes = usePlanChanges();
    const shouldBlock = Object.keys(changes || {}).length > 0;
    return <Blocker shouldBlock={shouldBlock} />;
}

export default PlanBlocker;
